import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataCustomDocument } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
import type { NodeProps } from '../../playbook-builder.types';
import type { ApplyEditMutation } from '../base-node';
import Section from '../section';
import Form from './form';
type DrawerContentProps = {
  node: NodeProps<ApiNodeDataCustomDocument>;
  mutation: ApplyEditMutation;
  canEdit: boolean;
  isFirmEmployee: boolean;
};
const DrawerContent = t0 => {
  const $ = _c(26);
  const {
    node,
    mutation,
    canEdit,
    isFirmEmployee
  } = t0;
  const {
    id,
    data
  } = node;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "builder.nodes.document"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-details", t1);
  if (!data.document || data.document.kind === "custom") {
    let t2;
    if ($[1] !== canEdit || $[2] !== data.document || $[3] !== data.verificationSettings || $[4] !== id || $[5] !== isFirmEmployee || $[6] !== mutation) {
      t2 = <Form nodeId={id} document={data.document} verificationSettings={data.verificationSettings} isFirmEmployee={isFirmEmployee} mutation={mutation} canEdit={canEdit} />;
      $[1] = canEdit;
      $[2] = data.document;
      $[3] = data.verificationSettings;
      $[4] = id;
      $[5] = isFirmEmployee;
      $[6] = mutation;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  if (data.document.kind === "proof_of_address") {
    let t2;
    if ($[8] !== t) {
      t2 = t(_temp);
      $[8] = t;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== t) {
      t3 = t(_temp2);
      $[10] = t;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== t3) {
      t4 = <div className="text-body-2 text-tertiary">{t3}</div>;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== t2 || $[15] !== t4) {
      t5 = <Section title={t2}>{t4}</Section>;
      $[14] = t2;
      $[15] = t4;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    return t5;
  }
  if (data.document.kind === "proof_of_ssn") {
    let t2;
    if ($[17] !== t) {
      t2 = t(_temp3);
      $[17] = t;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    let t3;
    if ($[19] !== t) {
      t3 = t(_temp4);
      $[19] = t;
      $[20] = t3;
    } else {
      t3 = $[20];
    }
    let t4;
    if ($[21] !== t3) {
      t4 = <div className="text-body-2 text-tertiary">{t3}</div>;
      $[21] = t3;
      $[22] = t4;
    } else {
      t4 = $[22];
    }
    let t5;
    if ($[23] !== t2 || $[24] !== t4) {
      t5 = <Section title={t2}>{t4}</Section>;
      $[23] = t2;
      $[24] = t4;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    return t5;
  }
};
export default DrawerContent;
function _temp($) {
  return $.label.poa;
}
function _temp2($_0) {
  return $_0.description.poa;
}
function _temp3($_1) {
  return $_1.label.ssn;
}
function _temp4($_2) {
  return $_2.description.ssn;
}